import { Divider, IconButton, Input, List, ListItem, ListItemSecondaryAction, ListItemText, Select } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { getCategories } from 'src/utils/storage/commentCategories';
import logger from 'src/utils/logger';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  rootDetay: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    flexGrow: 1,
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5, 2)
  },
  input: {
    width: '100%'
  },
  divider: {
    width: 1,
    height: 24
  },
  fileInput: {
    display: 'none'
  }
}));

function ConversationForm({ className, messages, ...rest }) {
  const classes = useStyles();
  const [value, setValue] = useState('');
  const history = useHistory();
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const [uyari, setUyari] = React.useState(false);
  const [KararData, setKararData] = React.useState([]);
  const [uyariTip, setUyariTip] = React.useState();
  const [valueKarar, setvalueKarar] = React.useState(0);
  const SessionUser = getUser();
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  useEffect(() => {
    const fetchCategories = async () => {
      let cat = await getCategories();
      setKararData(cat);
    }
    fetchCategories();
  }, []);

  const handleChange = (event) => {
    event.persist();
    setValue(event.target.value);
  }

  const YorumGonder = () => {
    if (value === "") {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: "Lütfen yorum giriniz!..." })
      setUyariTip("error");
      setUyari(true);
      return;
    }
    const data = [{
      AppNr: messages[0]?.BASVURU_NO,
      ServiceShopId: messages[0]?.BIRIM_KODU,
      CommentRequested: SessionUser.ServiceShopId,
      UserId: SessionUser.ServiceShopId === 99 ? SessionUser.TechnicianId : messages[0]?.TEKNISYEN_KODU,
      Comment: value,
      Operation: 1,
      CommentId: 0,
      Decision: valueKarar,
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetArtemisComment', data, config).then(response => {

      let ResponseData = response.data;
      setresponseMessage(ResponseData);
      if (ResponseData.ErrorCode === "0") {
        history.push("/chat");
      } else {
        setUyariTip("error");
      }
      setUyari(true);
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });
  }
  const handleChangeKarar = (e) => {
    setvalueKarar(e.target.value);
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.rootDetay}
      >
        <ListItem button>
          <ListItemText>
            <Select
              native
              value={valueKarar}
              onChange={handleChangeKarar}
              label="Karar"
              fullWidth
              labelId="karar_label"
              inputProps={{
                name: "karar_select",
                id: "karar_select"
              }}
            >
              <option value="0" defaultValue>Kategori Seçiniz!...</option>
              {KararData.filter(k => k.TIP === (SessionUser.ServiceShopId === 99 ? "BOLGE" : "SERVIS")).map(p => {
                return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
              })}
            </Select>
          </ListItemText>
        </ListItem>
        <ListItem button>
          <ListItemText>
            {uyari &&
              <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
            }
            <Input
              disableUnderline
              multiline={true}
              onChange={handleChange}
              placeholder="Yorum Yaz..."
              fullWidth={true}
            />
          </ListItemText>
          <ListItemSecondaryAction className={classes.nested}>
            <IconButton
              color="primary"
              edge="end"
              onClick={YorumGonder}
              size="small">
              <SendIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>





      <Divider className={classes.divider} />

    </div>
  );
}

ConversationForm.propTypes = {
  className: PropTypes.string
};

export default ConversationForm;
